import React from 'react';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';

import { useTranslation } from 'react-i18next';



function LayersIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className="size-6 text-teal-500"
      {...props}
    >
      <path d="M16.5 6a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v7.5a3 3 0 0 0 3 3v-6A4.5 4.5 0 0 1 10.5 6h6Z" />
      <path d="M18 7.5a3 3 0 0 1 3 3V18a3 3 0 0 1-3 3h-7.5a3 3 0 0 1-3-3v-7.5a3 3 0 0 1 3-3H18Z" />
    </svg>
  );
}

function FadeInSection({ children }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 1.2, ease: 'easeOut' }}
    >
      <div className="max-w-screen-xl mx-auto w-full px-4 sm:px-6 lg:px-8">
        {children}
      </div>
    </motion.div>
  );
}

const AboutPage = () => {

  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50">
      <FadeInSection>
        <section className="relative py-20 overflow-hidden">
          <div className="grid gap-12 sm:grid-cols-2 items-center">
            <div className="space-y-8">
              <h1 className="text-4xl sm:text-5xl mt-12 md:text-6xl font-bold tracking-tight text-slate-900">
               {t('about.heading')}
              </h1>
              <p className="text-lg text-gray-600">
               {t('about.intro')}
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                {/* <button className="px-6 py-3 bg-teal-500 text-white font-semibold rounded-lg hover:bg-teal-600 transition">
                  Get Started
                </button>
                <button className="px-6 py-3 border border-teal-500 text-teal-500 font-semibold rounded-lg hover:bg-teal-500 hover:text-white transition">
                  Learn More
                </button> */}
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="overflow-hidden rounded-lg">
                <img
                  src="https://metropolitan.realestate/wp-content/uploads/2024/10/Marina-Cove-in-Dubai-Marina-MPP.webp"
                  alt="Property"
                  className="object-cover w-full h-full aspect-[4/5] transition-transform duration-300 ease-in-out hover:scale-105"
                />
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-1 gap-4">
                <div className="overflow-hidden rounded-lg">
                  <img
                    src="https://customersfirstacademy.com/wp-content/uploads/2021/04/strategies-for-Creating-a-Happy-Customer-1024x576.jpg"
                    alt="Customer"
                    className="object-cover w-full h-full aspect-square transition-transform duration-300 ease-in-out hover:scale-105"
                  />
                </div>
                <div className="overflow-hidden rounded-lg">
                  <img
                    src="https://media.istockphoto.com/id/624155142/photo/three-construction-workers-preparing-for-work.jpg?s=612x612&w=0&k=20&c=NzXc4lRFYUaZHncz3a2_9-fzeQWGIcPeVxbTM93GP30="
                    alt="Workers"
                    className="object-cover w-full h-full aspect-square transition-transform duration-300 ease-in-out hover:scale-105"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </FadeInSection>

      <FadeInSection>
        <section className="py-20">
          <h2 className="text-5xl font-bold text-slate-900 mb-12">{t('about.mission_title')}</h2>
          <div className="grid gap-12 md:grid-cols-2">
            <div className="space-y-6 text-lg text-gray-600">
              <p>
                {t('about.mission_1')}              </p>
              <p>
              {t('about.mission_2')}              </p>
            </div>
            <div className="grid grid-cols-2 gap-8">
              {[
                 ['5,000+', t('about.stats.listings')],
                ['AED 10B+', t('about.stats.value')],
                ['30+', t('about.stats.partners')],
                ['4.9/5', t('about.stats.satisfaction')],
              ].map(([num, label]) => (
                <div key={label} className="space-y-1">
                  <h3 className="text-4xl font-bold text-teal-500">{num}</h3>
                  <p className="text-sm text-gray-700">{label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </FadeInSection>

      <FadeInSection>
        <section className="py-20 bg-slate-50">
          <h2 className="text-5xl font-bold text-slate-900 mb-12">{t('about.values_title')}</h2>
          <div className="grid gap-8 md:grid-cols-3">
            {[
  'world_class',
  'insights',
  'innovate',
  'supportive',
  'responsible',
  'enjoy'
]
.map((key) => (
              <div key={key} className="space-y-4">
                <div className="flex items-center gap-3">
                  <LayersIcon />
                  <h3 className="text-xl font-semibold text-teal-600">{t(`about.values.${key}`)}</h3>
                </div>
                <p className="text-gray-600 text-sm">
                   {t(`about.values_desc.${key}`)}
                </p>
              </div>
            ))}
          </div>
        </section>
      </FadeInSection>

      {/* <FadeInSection>
        <section className="py-20">
          <h2 className="text-5xl font-bold text-slate-900 mb-4">Our Blog</h2>
          <p className="text-lg text-gray-600 mb-10">Stay ahead of the market with insights from our experts.</p>
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {blogPosts.map((post) => (
              <div key={post.title} className="bg-gray-50 rounded-lg shadow-sm hover:shadow-md transition overflow-hidden">
                <img src={post.image} alt={post.title} className="w-full aspect-video object-cover" />
                <div className="p-6 space-y-3">
                  <div className="text-sm text-gray-500 flex items-center gap-2">
                    <span>{post.date}</span>
                    <span>•</span>
                    <span>{post.author}</span>
                  </div>
                  <h3 className="text-xl font-bold text-slate-800">{post.title}</h3>
                  <p className="text-gray-600">{post.excerpt}</p>
                  <button className="text-teal-600 font-medium hover:underline">Read more →</button>
                </div>
              </div>
            ))}
          </div>
        </section>
      </FadeInSection> */}

      <Footer />
    </div>
  );
};

export default AboutPage;
